/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './account.js';
import './actions.js';
import './activities.js';
import './alertEvents.js';
import './alertRules.js';
import './api.js';
import './app.js';
import './batch.js';
import './billing.js';
import './bulkrestore.js';
import './gdprrequest.js';
import './config.js';
import './dashboard.js';
import './metadata.js';
import './metadataCompare.js';
import './metadataRestore.js';
import './notifications.js';
import './permissions.js';
import './progress.js';
import './queue.js';
import './sobject.js';
import './users.js';

/**
 * Grouping module used for including all http sub-modules in the project.
 */
angular.module('sbsf.http', [
  'http.account',
  'http.actions',
  'http.activities',
  'http.api',
  'http.app',
  'http.billing',
  'http.batch',
  'http.bulkrestore',
  'http.gdprrequest',
  'http.config',
  'http.dashboard',
  'http.metadata',
  'http.metadataCompare',
  'http.metadataRestore',
  'http.notifications',
  'http.permissions',
  'http.progress',
  'http.sobject',
  'http.queue',
  'http.users'
]);
